'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CharacterStylesPopupPlugin;
var _reactDom = require("react-dom");
var _react = _interopRequireWildcard(require("react"));
var _lexical = require("lexical");
var _link = require("@lexical/link");
var _LexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _selection = require("@lexical/selection");
var _utils = require("@lexical/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
function setPopupPosition(editor, rect) {
  const dist_from_selection = 20; // tooltip minimum distance from selected text

  if (rect === null) {
    editor.style.opacity = '0';
    editor.style.top = '-1000px';
    editor.style.left = '-1000px';
  } else {
    const tooltip_height = editor.offsetHeight;
    const tooltip_width = editor.offsetWidth;
    editor.style.opacity = '1';
    const selection_middle = rect.top + rect.height / 2 + window.pageYOffset;
    editor.style.top = selection_middle - tooltip_height / 2 + 'px';
    let left_pos = rect.left + window.pageXOffset + rect.width + dist_from_selection;

    // distance from right border of the screen
    const right_pos = window.innerWidth - (left_pos + tooltip_width);

    // missing a few pixels to let 5 pixels between tooltip and screen border
    if (right_pos < 5 && right_pos > 0) {
      left_pos = left_pos -= 5 - right_pos;
    }
    // sticking at right of the screen would overlay the current selection
    else if (right_pos < 0) {
      left_pos = rect.left - dist_from_selection - tooltip_width;
    }
    if (left_pos < 5) left_pos = 5;
    editor.style.left = left_pos + 'px';
  }
}
function FloatingCharacterStylesEditor(_ref) {
  let {
    editor,
    isLink,
    isBold,
    isItalic,
    isUnderline,
    isStrikethrough
  } = _ref;
  const popupCharStylesEditorRef = (0, _react.useRef)(null);
  const mouseDownRef = (0, _react.useRef)(false);
  const insertLink = (0, _react.useCallback)(() => {
    if (!isLink) {
      editor.dispatchCommand(_link.TOGGLE_LINK_COMMAND, 'https://');
    } else {
      editor.dispatchCommand(_link.TOGGLE_LINK_COMMAND, null);
    }
  }, [editor, isLink]);
  const updateCharacterStylesEditor = (0, _react.useCallback)(() => {
    const selection = (0, _lexical.$getSelection)();
    const popupCharStylesEditorElem = popupCharStylesEditorRef.current;
    const nativeSelection = window.getSelection();
    if (popupCharStylesEditorElem === null) return;
    const rootElement = editor.getRootElement();
    if (selection !== null && !nativeSelection.isCollapsed && rootElement !== null && rootElement.contains(nativeSelection.anchorNode)) {
      const domRange = nativeSelection.getRangeAt(0);
      let rect;
      if (nativeSelection.anchorNode === rootElement) {
        let inner = rootElement;
        while (inner.firstElementChild != null) {
          inner = inner.firstElementChild;
        }
        rect = inner.getBoundingClientRect();
      } else {
        rect = domRange.getBoundingClientRect();
      }
      if (!mouseDownRef.current) {
        setPopupPosition(popupCharStylesEditorElem, rect);
      }
    }
  }, [editor]);
  (0, _react.useEffect)(() =>
  // update would not fire when double-clicking to select text
  {
    editor.getEditorState().read(() => updateCharacterStylesEditor());
  }, []);
  (0, _react.useEffect)(() => {
    return (0, _utils.mergeRegister)(editor.registerUpdateListener(_ref2 => {
      let {
        editorState
      } = _ref2;
      editorState.read(() => updateCharacterStylesEditor());
    }), editor.registerCommand(_lexical.SELECTION_CHANGE_COMMAND, () => {
      updateCharacterStylesEditor();
      return false;
    }, _lexical.COMMAND_PRIORITY_LOW));
  }, [editor, updateCharacterStylesEditor]);
  const output = /*#__PURE__*/_react.default.createElement("div", {
    ref: popupCharStylesEditorRef,
    className: "character-style-popup"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, 'bold'),
    className: 'popup-item spaced ' + (isBold ? 'active' : ''),
    "aria-label": "Mettre en gras"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "format bold"
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, 'italic'),
    className: 'popup-item spaced ' + (isItalic ? 'active' : ''),
    "aria-label": "Mettre en italique"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "format italic"
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, 'underline'),
    className: 'popup-item spaced ' + (isUnderline ? 'active' : ''),
    "aria-label": "Souligner"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "format underline"
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, 'strikethrough'),
    className: 'popup-item spaced ' + (isStrikethrough ? 'active' : ''),
    "aria-label": "Barrer"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "format strikethrough"
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: insertLink,
    className: 'popup-item spaced ' + (isLink ? 'active' : ''),
    "aria-label": "Ins\xE9rer un lien"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "format link"
  })));
  return output;
}
function getSelectedNode(selection) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = selection.anchor.getNode();
  const focusNode = selection.focus.getNode();
  if (anchorNode === focusNode) return anchorNode;
  const isBackward = selection.isBackward();
  return isBackward ? (0, _selection.$isAtNodeEnd)(focus) ? anchorNode : focusNode : (0, _selection.$isAtNodeEnd)(anchor) ? focusNode : anchorNode;
}
function useCharacterStylesPopup(editor) {
  const [isText, setIsText] = (0, _react.useState)(false);
  const [isLink, setIsLink] = (0, _react.useState)(false);
  const [isBold, setIsBold] = (0, _react.useState)(false);
  const [isItalic, setIsItalic] = (0, _react.useState)(false);
  const [isUnderline, setIsUnderline] = (0, _react.useState)(false);
  const [isStrikethrough, setIsStrikethrough] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    return editor.registerUpdateListener(_ref3 => {
      let {
        editorState
      } = _ref3;
      editorState.read(() => {
        const selection = (0, _lexical.$getSelection)();
        if (!(0, _lexical.$isRangeSelection)(selection)) {
          setIsLink(false);
          setIsText(false);
          return;
        }
        const node = getSelectedNode(selection);

        // Update text format
        setIsBold(selection.hasFormat('bold'));
        setIsItalic(selection.hasFormat('italic'));
        setIsUnderline(selection.hasFormat('underline'));
        setIsStrikethrough(selection.hasFormat('strikethrough'));

        // Update links
        const parent = node.getParent();
        if ((0, _link.$isLinkNode)(parent) || (0, _link.$isLinkNode)(node)) {
          setIsLink(true);
        } else {
          setIsLink(false);
        }
        if (selection.getTextContent() !== '') {
          setIsText((0, _lexical.$isTextNode)(node));
        } else {
          setIsText(false);
        }
      });
    });
  }, [editor]);
  if (!isText || isLink) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(FloatingCharacterStylesEditor, {
    editor: editor,
    isLink: isLink,
    isBold: isBold,
    isItalic: isItalic,
    isStrikethrough: isStrikethrough,
    isUnderline: isUnderline
  }), document.body);
}
function CharacterStylesPopupPlugin() {
  const [editor] = (0, _LexicalComposerContext.useLexicalComposerContext)();
  return useCharacterStylesPopup(editor);
}
